import { render, staticRenderFns } from "./OffersFullScreen.vue?vue&type=template&id=6013d544&"
import script from "./OffersFullScreen.vue?vue&type=script&lang=js&"
export * from "./OffersFullScreen.vue?vue&type=script&lang=js&"
import style0 from "./OffersFullScreen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports